/**
 * API do painel v2 — Avisos aos clientes e Provisionar cliente.
 *
 * Endpoints do painel (cross-tenant, operador da Pharu): nada daqui é
 * chamado de dentro de uma tela do ERP. A faixa do ERP usa só
 * `carregarAvisosAtivos` (`/api/plataforma/*`, a unidade vem da sessão).
 */

const SILENCIOSO = { silentError: true };

/* ---------------- Avisos (painel) ---------------- */

export function listarAvisos(request, { situacao = "", busca = "", pagina = 1 } = {}) {
  const qs = new URLSearchParams();
  if (situacao) qs.set("situacao", situacao);
  if (busca) qs.set("busca", busca);
  if (pagina > 1) qs.set("pagina", String(pagina));
  const sufixo = qs.toString() ? `?${qs}` : "";
  return request(`/api/painel/avisos${sufixo}`, SILENCIOSO);
}

export function criarAviso(request, dados) {
  return request("/api/painel/avisos", { ...SILENCIOSO, method: "POST", body: JSON.stringify(dados) });
}

export function editarAviso(request, id, dados) {
  return request(`/api/painel/avisos/${id}`, { ...SILENCIOSO, method: "PATCH", body: JSON.stringify(dados) });
}

export function encerrarAviso(request, id) {
  return request(`/api/painel/avisos/${id}/encerrar`, { ...SILENCIOSO, method: "POST" });
}

export function buscarClientesParaAviso(request, busca = "") {
  const sufixo = busca ? `?busca=${encodeURIComponent(busca)}` : "";
  return request(`/api/painel/avisos/clientes${sufixo}`, SILENCIOSO);
}

/* ---------------- Avisos (ERP do cliente) ---------------- */

/** A faixa do ERP: avisos no ar para a unidade da sessão. */
export function carregarAvisosAtivos(request) {
  return request("/api/plataforma/avisos-ativos", SILENCIOSO);
}

/* ---------------- Provisionar ---------------- */

export function carregarProvisionar(request, leadId) {
  const sufixo = leadId ? `?lead=${encodeURIComponent(leadId)}` : "";
  return request(`/api/painel/provisionar${sufixo}`, SILENCIOSO);
}

export function provisionar(request, dados) {
  return request("/api/painel/provisionar", { ...SILENCIOSO, method: "POST", body: JSON.stringify(dados) });
}

export function consultarCnpj(request, cnpj) {
  const digitos = String(cnpj || "").replace(/\D/g, "");
  return request(`/api/painel/provisionar/cnpj/${digitos}`, SILENCIOSO);
}

/** Preço SÓ pelo catálogo (`services_planos.calcular_preco`, endpoint do Financeiro). */
